import { useEffect, useRef } from "react"

/**
 * La durée d'un bandeau : un bandeau porteur d'action ne se retire pas seul quand un lecteur d'écran est
 * actif, le temps d'atteindre son bouton dépassant souvent sa durée (WCAG 2.2.1). `0` : jusqu'au geste.
 */
export function snackbarAutoHideMs(
    autoHideMs: number,
    { hasAction, screenReader }: { hasAction: boolean; screenReader: boolean }
): number {
    return hasAction && screenReader ? 0 : autoHideMs
}

/**
 * Le masquage seul de `<Snackbar>` : `onDismiss` au bout de `autoHideMs`, compté depuis l'apparition.
 * `onDismiss` est lu dans une ref : un appelant qui le passe en ligne ne relance pas le compte à
 * chaque rendu, sinon une page qui se redessine avant la fin garderait la bande affichée.
 * `restartKey` (le message de la bande) relance le compte : un message qui prend la place d'un autre
 * encore visible a toute sa durée, pas le reste de celle du premier.
 */
export function useAutoHide(visible: boolean, autoHideMs: number, onDismiss: () => void, restartKey?: unknown): void {
    const onDismissRef = useRef(onDismiss)
    onDismissRef.current = onDismiss

    useEffect(() => {
        if (!visible || autoHideMs <= 0) return
        const timer = setTimeout(() => onDismissRef.current(), autoHideMs)
        return () => clearTimeout(timer)
    }, [visible, autoHideMs, restartKey])
}
